import { BOOKING_URL } from '../constants';
import { gsap, splitLines, useMotion } from '../lib/motion';

const HERO_IMAGE = "/sacolas-loja.jpg";

export default function Hero() {
  const scope = useMotion((root) => {
    const photo = root.querySelector('[data-hero-photo]');
    const img = photo.querySelector('img');
    const eyebrow = root.querySelector('[data-hero-eyebrow]');
    const sub = root.querySelector('[data-hero-sub]');
    const ctas = root.querySelectorAll('[data-hero-cta] > a');

    // Abertura: foto se revela, título sobe linha a linha, depois texto e botões.
    splitLines(root.querySelector('h1'), (self) =>
      gsap
        .timeline({ defaults: { ease: 'expo.out', duration: 1.1 } })
        .from(photo, { clipPath: 'inset(100% 0% 0% 0% round 16px)', duration: 1.4, ease: 'expo.inOut' }, 0)
        .from(img, { scale: 1.4, duration: 2 }, 0)
        .from(eyebrow, { autoAlpha: 0, y: 12, duration: 0.8 }, 0.15)
        .from(self.lines, { yPercent: 110, stagger: 0.1 }, 0.2)
        .from(sub, { autoAlpha: 0, y: 16 }, 0.5)
        .from(ctas, { autoAlpha: 0, y: 16, stagger: 0.08 }, 0.6)
    );
  });

  return (
    <section ref={scope} id="inicio" data-testid="hero-section" className="max-w-7xl mx-auto px-4 md:px-8 pt-8 pb-16 md:pt-12 md:pb-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 items-center">
        <div className="md:col-span-6 lg:col-span-6">
          <p data-hero-eyebrow className="text-sm font-semibold text-tan mb-5">Trancista em Campinas, SP</p>

          <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight leading-[0.95] text-ink mb-6 text-balance">
            Tranças para cabelo <span className="text-tan">crespo e cacheado</span>
          </h1>

          <p data-hero-sub className="text-lg text-soft leading-relaxed max-w-[42ch] mb-8">
            Box braids, knotless, nagô e twists. Escolha estilo e horário online e só pague depois da aprovação.
          </p>

          <div id="hero-cta" data-hero-cta className="flex flex-col sm:flex-row gap-3">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-magnetic
              className="inline-flex justify-center items-center bg-ink text-paper px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap hover:bg-tan transition-colors"
              data-testid="hero-booking-btn"
            >
              Agendar horário
            </a>
            <a
              href="#portfolio"
              className="inline-flex justify-center items-center border border-ink/20 text-ink px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap hover:border-ink transition-colors"
              data-testid="hero-portfolio-link"
            >
              Ver trabalhos
            </a>
          </div>
        </div>

        <div className="md:col-span-6 lg:col-span-5 lg:col-start-8">
          <div
            data-hero-photo
            className="w-full overflow-hidden rounded-2xl"
          >
            <img
              src={HERO_IMAGE}
              alt="Sacolas personalizadas com a logo Nyjuliabraids"
              width="528"
              height="399"
              fetchPriority="high"
              className="block w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
